export default [
    {
        name: 'device',
        type: 'gltfModel',
        path: 'models/TamagotchiDevice/tamagotchi.gltf',
        scale: 1,
        position: [0, 0, 0],
        rotation: [0, 0, 0]
    },
    {
        name: 'icon1',
        type: 'gltfModel',
        path: 'models/ScreenIcons/Food/blood.gltf',
        scale: 0.35,
        position: [-0.75, -1.3, 0.65],
        rotation: [1.5, 0, -0.5]
    },
    {
        name: 'icon2',
        type: 'gltfModel',
        path: 'models/ScreenIcons/Sleep/coffin.gltf',
        scale: 0.15,
        position: [-0.25, -1.3125, 0.65],
        rotation: [1.5, 0, 0]
    },
    {
        name: 'icon3',
        type: 'gltfModel',
        path: 'models/ScreenIcons/Game/batbat.gltf',
        scale: 0.02,
        position: [0.25, -1.3, 0.65],
        rotation: [1.5, 0, 1]
    },
    {
        name: 'icon4',
        type: 'gltfModel',
        path: 'models/ScreenIcons/Medicine/medicine.gltf',
        scale: 0.15,
        position: [0.75, -1.3, 0.65],
        rotation: [1.5, 0, 1]
    },
    {
        name: 'icon5',
        type: 'gltfModel',
        path: 'models/ScreenIcons/Medicine/medicine.gltf',
        scale: 0.15,
        position: [-0.75, -0.1, 0.65],
        rotation: [1.5, 0, 0]
    },
    {
        name: 'icon6',
        type: 'gltfModel',
        path: 'models/ScreenIcons/Medicine/medicine.gltf',
        scale: 0.15,
        position: [-0.25, -0.1, 0.65],
        rotation: [1.5, 0, 0]
    },
    {
        name: 'icon7',
        type: 'gltfModel',
        path: 'models/ScreenIcons/Medicine/medicine.gltf',
        scale: 0.15,
        position: [0.25, -0.1, 0.65],
        rotation: [1.5, 0, 0]
    },
    {
        name: 'icon8',
        type: 'gltfModel',
        path: 'models/ScreenIcons/Medicine/medicine.gltf',
        scale: 0.15,
        position: [0.75, -0.1, 0.65],
        rotation: [1.5, 0, 0]
    },    
    {
        name: 'device_change_cover',
        type: 'gltfModel',
        path: 'models/TamagotchiDevice/tamagotchi.gltf',
        scale: 1,
        position: [20, 0, 20],
        rotation: [0.25, 0, 0]
    },    
    {
        name: 'vampire',
        type: 'gltfModel',
        path: 'models/Vampire/vampire_longbody.gltf',
        scale: 0.3,
        position: [0, -0.45, 0.5],
        rotation: [1.5, 0, 1]
    },    
    {
        name: 'vampire_longbody',
        type: 'gltfModel',
        path: 'models/Vampire/vampire_longbody.gltf',
        scale: 1.2,
        position: [-20.3, 0, -21],
        rotation: [1.75, 0.05, 1.05],
        // position: [-19, 0,2, -16.4],
        // rotation: [1.75, 0.2, 1.4]
    }
]